export default __webpack_public_path__ + "static/media/newlogo.cdba494a.svg";